import React from 'react';
import { Faq } from './Faq';
import { FinalClose } from './FinalClose';
import { Footer } from './Footer';
import { ForYou } from './ForYou';
import { Guarantee } from './Guarantee';
import { Reflection } from './Reflection';
interface LateContentProps {
  onCta: () => void;
}

/** Lower-priority conversion content loaded only as visitors approach it. */
export function LateContent({
  onCta
}: LateContentProps) {
  return <>
      <Guarantee data-id="element-157" data-mp="2icsybnibngs4" />
      <Reflection data-id="element-158" data-mp="2iedicj70fhbq" />
      <ForYou data-id="element-159" data-mp="2dd6bcmcoym64" />
      <Faq data-id="element-160" data-mp="2ddpta32cdak5" />
      <FinalClose onCta={onCta} data-id="element-161" data-mp="2ddy7pze44nxg" />
      <Footer data-id="element-162" data-mp="2df0wa0nyqea7" />
    </>;
}